import { render, staticRenderFns } from "./Restore.vue?vue&type=template&id=309da612&scoped=true&"
import script from "./Restore.vue?vue&type=script&lang=ts&"
export * from "./Restore.vue?vue&type=script&lang=ts&"
import style0 from "./Restore.vue?vue&type=style&index=0&id=309da612&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309da612",
  null
  
)

export default component.exports